import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class Keywords extends Resource {
  public static type = 'keywords';

  @prop
  public name: string;
}
